<!-- Features Table -->
<div class="feature-container">
	<h2>Features</h2>
	<div class="table-container">
		<div class="table-border">
			<div class="features-table">
				<table id="features-table">
					<thead>
						<tr class="text-center mb-2" style="font-weight: bold; color: #ef5a23; font-size: large;">
							<td>Feature</td>
							<td>Community Edition (CE)</td>
							<td>Enterprise Edition (EE)</td>
							<td>Managed Edition (ME)</td>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let f of features" class="mt-1">
							<td><a [routerLink]="f.link" [title]="f.description">{{ f.title }}</a></td>
							<td><i [class]="f.ce" [ngStyle]="{'color': f.ce.indexOf('times') > 0 ? 'red' : 'green' }"></i></td>
							<td><i [class]="f.ee" [ngStyle]="{'color': f.ee.indexOf('times') > 0 ? 'red' : 'green' }"></i></td>
							<td><i [class]="f.ms" [ngStyle]="{'color': f.ms.indexOf('times') > 0 ? 'red' : 'green' }"></i></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>